<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel120">Direct Credit</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Form v-show="!showConfirm" class="form form-horizontal">
              <div class="row">
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-12 col-form-label">
                      <select class="form-control" v-model="directType">
                        <option value="1">Direct Refund</option>
                        <option value="2">Direct Withdrawal</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row" v-show="directType == 2">
                    <div class="col-12 col-form-label">
                      <SelectOptions
                          label=""
                          selectAppend="currency"
                          labelValue="code"
                          :filter="{ flag: 'active' }"
                          :modelValue.sync="selectedAccount"
                          url="v1/get-currency"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12 col-form-label">
                      <label>Amount</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12">
                      <div class="input-group">
                        <input
                            type="text"
                            v-model="amount"
                            class="form-control"
                            :disabled="!isPartial"
                            :class="
                                  errorBag.has('amount') ? 'is-invalid' : ''
                                "
                            name="amount"
                            v-validate="'required'"
                        />
                        <small
                            v-show="errorBag.has('amount')"
                            class="invalid-feedback"
                        >{{ "*" + errorBag.first("amount") }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12 col-form-label">
                      <label>Description</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12">
                      <div class="input-group">
                         <textarea
                             class="form-control"
                             v-model="description"
                             name="description"
                         >
                      </textarea>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row" v-show="directType != 2">
                    <div class="col-12">
                      <div class="custom-control custom-control-primary custom-checkbox">
                        <input name="isPartial" type="checkbox" v-model="isPartial"
                               class="custom-control-input" id="colorCheck1"/>
                        <label class="custom-control-label" for="colorCheck1">Partial</label>
                      </div>
                    </div>

                  </div>
                  <div class="form-group row d-flex justify-content-end">
                    <!--                    <button :ref="transactionId" style="display:none;" type="button">Submit</button>-->
                    <button
                        type="button"
                        class="btn btn-primary mr-1 d-flex "
                        @click="loadConfirmModal"
                        :disabled="loader"
                    >
                      <Loader :loading="loader" size="10px"></Loader>
                      Create
                    </button>
                    <!--                    <button type="button"  class="btn btn-primary mr-1"  @click="sendCall()">Create</button>-->
                  </div>
                </div>
              </div>
            </form>
            <div class="col-12" v-show="showConfirm">
              <div class="text-center">
                <h2>Are you sure to proceed?</h2>
              </div>
              <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-gradient-danger" data-dismiss="modal" @click="showConfirm = false">
                  No
                </button>
                <button
                    type="button"
                    class="btn btn-gradient-success mr-1 d-flex "
                    @click="sendCall"
                    :disabled="loader"
                >
                  <Loader :loading="loader" size="10px"></Loader>
                  Yes
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show', 'transactionId', 'refundInitialAmount'],
  data() {
    return {
      directType:1,
      list: [],
      isPartial: false,
      description: '',
      amount: '',
      loader: false,
      showConfirm: false,
      selectedAccount: null,
    }
  },
  mounted() {
  },
  methods: {
    loadConfirmModal() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.showConfirm = true
        }
      })
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loader = true
          let data = {
            amount: this.amount * 100,
            description: this.description,

            transactionId: this.transactionId,
            directCredit: parseInt(this.directType)
          }
          if(this.directType == 2){
            if(this.selectedAccount){
              data.currencyId = this.selectedAccount.id
            }
          }else{
            data.isPartial = this.isPartial ? 1 : 0
          }
          this.makeRequest('post', 'v1/create-refund-request', data).then(callResponse => {

            this.loader = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;

              if (code == 200) {
                this.$emit('hide')
              }

            }


          });
        }
      })


    },
  },
  watch: {
    show(val) {
      if (val) {
        this.amount = this.refundInitialAmount
        this.isPartial = false
        this.description = ''
        this.showConfirm = false
        this.directType = 1
      }

    },
    directType(val){
      if(val == 2){
        this.isPartial = true
      }
    },
    isPartial(val) {
      if (!val) {
        this.amount = this.refundInitialAmount
      }
    }
  }
}
</script>

<style scoped>

/*--thank you pop starts here--*/
.thank-you-pop {
  width: 100%;
  padding: 20px;
  text-align: center;
}

.thank-you-pop img {
  width: 76px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 25px;
}

.thank-you-pop h1 {
  font-size: 42px;
  margin-bottom: 25px;
  color: #5C5C5C;
}

.thank-you-pop p {
  font-size: 20px;
  margin-bottom: 27px;
  color: #5C5C5C;
}

.thank-you-pop h3.cupon-pop {
  font-size: 25px;
  margin-bottom: 40px;
  color: #222;
  display: inline-block;
  text-align: center;
  padding: 10px 20px;
  border: 2px dashed #222;
  clear: both;
  font-weight: normal;
}

.thank-you-pop h3.cupon-pop span {
  color: #03A9F4;
}

.thank-you-pop a {
  display: inline-block;
  margin: 0 auto;
  padding: 9px 20px;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  background-color: #8BC34A;
  border-radius: 17px;
}

.thank-you-pop a i {
  margin-right: 5px;
  color: #fff;
}

#ignismyModal .modal-header {
  border: 0px;
}

/*--thank you pop ends here--*/

</style>

